import { createClient } from '@supabase/supabase-js'
import { config } from './config'
import type { Database } from './database.types'

export const supabase = createClient<Database>(
  config.supabase.url,
  config.supabase.anonKey,
  {
    global: {
      fetch: (url, options) =>
        fetch(url, { ...options, signal: AbortSignal.timeout(4_000) }),
    },
    auth: {
      debug: false,
    },
  },
)

export async function healthCheck() {
  const { error } = await supabase.rpc('health_check')
  return !error
}
